import { render, staticRenderFns } from "./dog.vue?vue&type=template&id=e88d2fd4&scoped=true"
import script from "./dog.vue?vue&type=script&lang=js"
export * from "./dog.vue?vue&type=script&lang=js"
import style0 from "./dog.vue?vue&type=style&index=0&id=e88d2fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88d2fd4",
  null
  
)

export default component.exports